export const AFFIRM_INSTRUMENT_TYPE = 'bnpl/affirm';
export const AFFIRM_SUBMIT_INSTRUMENT_TYPE = 'buynowpaylater/affirm-vcn';

export const AFFIRM_LOGO_URL = 'https://cdn-assets.affirm.com/images/black_logo-transparent_bg.svg';

const AFFIRM_CDN_FALLBACK = {
  PRODUCTION: 'https://cdn1.affirm.com/js/v2/affirm.js',
  SANDBOX: 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js',
};

export const getAffirmScriptUrl = () => {
  if (process.env.REACT_APP_AFFIRM_CDN) return process.env.REACT_APP_AFFIRM_CDN;
  return process.env.REACT_APP_ENVIRONMENT === 'PRODUCTION'
    ? AFFIRM_CDN_FALLBACK.PRODUCTION
    : AFFIRM_CDN_FALLBACK.SANDBOX;
};

export const getAffirmPaymentMethodEntry = (sessionDetails) => (
  sessionDetails?.configs?.paymentMethods?.find((el) => (
    el.instrumentTypeValue === AFFIRM_INSTRUMENT_TYPE
    || el.brand?.toLowerCase() === 'affirm'
  ))
);

export const getAffirmConfig = (sessionDetails) => {
  const additionalData = getAffirmPaymentMethodEntry(sessionDetails)?.additionalData || {};


  return {
    publicApiKey: additionalData.publicApiKey || process.env.REACT_APP_AFFIRM_PUBLIC_API_KEY,
    scriptUrl: getAffirmScriptUrl(),
    useVcn: true,
  };
};
